import { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const BranchContext = createContext(null);

export function BranchProvider({ children }) {
  const { auth } = useAuth();
  const [branches, setBranches] = useState([]);
  const [selected, setSelected] = useState("all");

  const role = auth?.membership?.role;
  const assignedIds = auth?.membership?.branch_ids || [];

  const reload = useCallback(async () => {
    const { data } = await api.get("/branches");
    setBranches(data);
    return data;
  }, []);

  useEffect(() => {
    if (!auth?.membership) return;
    reload().then((data) => {
      const saved = localStorage.getItem("sp_branch");
      const valid = data.some((b) => b.branch_id === saved);
      if (role === "owner") {
        setSelected(valid ? saved : "all");
      } else {
        const writable = data.filter((b) => assignedIds.includes(b.branch_id));
        setSelected(valid && assignedIds.includes(saved) ? saved : writable[0]?.branch_id || "all");
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth?.membership?.membership_id]);

  const select = useCallback((id) => {
    setSelected(id);
    localStorage.setItem("sp_branch", id);
  }, []);

  const value = useMemo(() => {
    const writableBranches = role === "owner" ? branches : branches.filter((b) => assignedIds.includes(b.branch_id));
    return { branches, selected, select, writableBranches, reload, role };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branches, selected, select, reload, role, auth]);

  return (
    <BranchContext.Provider value={value}>
      {children}
    </BranchContext.Provider>
  );
}

export const useBranch = () => useContext(BranchContext);
